// Nikura Custom Code - Menu Banner Click - Start

(function () {
  'use strict';

  if (window.__nkMenuBannerInstalled) return;
  window.__nkMenuBannerInstalled = true;

  // Deduplicate this event object; distinct rapid clicks still count separately.
  const handledClicks = new WeakSet();

  document.addEventListener('click', function (e) {
    if (!e.target || e.target.nodeType !== 1) return;

    const a = e.target.closest && e.target.closest('a.bestseller-menu-link');
    if (!a) return;
    if (handledClicks.has(e)) return;
    handledClicks.add(e);

    const destination = a.getAttribute('href') || '';
    const list = document.querySelectorAll('a.bestseller-menu-link');
    const position = Array.from(list).indexOf(a) + 1;

    // Plain links navigate immediately, so push synchronously during capture.
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event:'menu_banner_click', banner_destination:destination, banner_position:position});
  }, true);
})();

// Nikura Custom Code - Menu Banner Click - End
